module.exports = __webpack_public_path__ + "static/media/Sayan_logo1.3b2c11d7.png";